<template>
  <div>
    <h2 class="title is-4">Organization Setup</h2>

    <div class="field">
      <label class="label">Name</label>
      <div class="control">
        <input
          v-model="form.name"
          class="input"
          type="text"
          placeholder="Organization name"
        />
      </div>
    </div>

    <div class="field">
      <label class="label">Organization Number</label>
      <div class="control">
        <input
          v-model="form.org_number"
          class="input"
          type="text"
          placeholder="BE1234567890"
        />
      </div>
    </div>

    <div class="field">
      <label class="label">Currency</label>
      <div class="control">
        <div class="select">
          <select v-model="form.currency">
            <option value="EUR">EUR (€)</option>
            <option value="USD">USD ($)</option>
            <option value="GBP">GBP (£)</option>
          </select>
        </div>
      </div>
    </div>

    <div class="buttons">
      <button class="button is-primary" @click="next">Next</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepOrganization',
  props: {
    wizardData: { type: Object, required: true },
  },
  data() {
    return {
      form: {
        name: this.wizardData.organization?.name || '',
        org_number: this.wizardData.organization?.org_number || '',
        currency: this.wizardData.organization?.currency || 'EUR',
      },
    };
  },
  methods: {
    next() {
      // ✅ Injecte bien les données dans wizardData.organization
      this.$emit('next', { organization: this.form });
    },
  },
};
</script>
